import React,{useState} from 'react'
import { Form, Input, Button, Spin } from 'antd';
import { AuthWrapper } from '../../style';
import OTPInput, { ResendOTP } from "otp-input-react";
import Heading from '../../../../../../components/heading/heading';
import { useDispatch, useSelector } from 'react-redux';
import { verifyOTPForgot, resendOTPForgot } from '../../../../../../redux/authentication/actionCreator';
import ReactGA from 'react-ga';
import classNames from 'classnames';
import "./OTP.css";


function OTP() {
    const [OTP, setOTP] = useState("");
    const dispatch = useDispatch();
    const dataForm = useSelector(state => state.auth.dataForm);
    const isLoading = useSelector(state => state.auth.loading);
    const otpBtn = (otpProp) => {
        if (otpProp.remainingTime === 0 ) {
            return (
                <button className="otp-resend-btn"
                  {...otpProp}>
                 {"HANTAR KOD OTP BARU"}
                </button>
            );
        }
    }
    const otpBtnTimer = (remainingTime) => {
        if (remainingTime !== 0) {
            return (
                <span className="otp-resend-btn" >
                 {`Sila tunggu ${remainingTime} saat`}
                </span>
              );
        }
    }
    
    const resendOTPFn = () => {
        const params = {
            msisdn: `${dataForm.msisdn}`,
            customerType: 'RECRUITER',
        }
        dispatch(resendOTPForgot(params) )
    }

    const submitOTP = () => {
        let param = {
            customerType: "RECRUITER",
            msisdn: `${dataForm.msisdn}`,
            otp: OTP,
            password: `${dataForm.password}`,
        }
        dispatch(verifyOTPForgot(param) )
    }
    return (
        <AuthWrapper>
      
      <div className="auth-contents">
        <Form name="register"  layout="vertical">
            <Heading as="h5">
            Sahkan Nombor Telefon
            </Heading>
            <p className="otp-head-text">
                Kami telah hantar kod pengesahan OTP<br />6-digit kepada <span className="bold">+{dataForm.msisdn}</span>
            </p>
            <OTPInput
                value={OTP}
                onChange={setOTP}
                autoFocus={false}
                OTPLength={6}
                otpType="number"
                className="otp-input"
                disabled={false} 
            />
            <p className="six-digit-text">Kod OTP 6-digit</p>
            <Button className="submit-btn" type="primary" size="large" disabled={OTP.length < 6 || isLoading}  onClick={submitOTP}>
                {(isLoading) ? (
                <Spin />
                ) : ("SAHKAN")}
            </Button>
            <p className="six-digit-text">Tidak terima kod OTP anda?</p>
            <ResendOTP 
                className="otp-resend" 
                maxTime={60}
                renderButton={otpBtn} 
                renderTime={otpBtnTimer} 
                onResendClick={resendOTPFn} />
        </Form>
      </div>
        
    </AuthWrapper>
    )
}

export default OTP
